var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post__container"},[_c('i',{staticClass:"fa fa-chevron-left post__back",attrs:{"aria-hidden":"true"},on:{"click":_vm.back}}),_c('div',{staticClass:"post__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }